<div class="scroll-holder chat-tabs">
  <div class="scroll-able">
    <div
      *ngFor="let conversation of conversations; index as i"
      [attr.data-test-id]="'conversation-' + i"
      (click)="onConversationSelected(conversation)"
      class="tab-block p-2"
      [ngClass]="{
        active: activeConversationId === conversation.conversationId
      }"
    >
      <app-small-profile-image
        [profileImage]="conversation.imageUrl"
        [accountStatus]="getParticipantsAccountStatus(conversation)"
        [dataTestId]="'conversation-avatar-' + i"
      ></app-small-profile-image>
      <div class="tab-body ms-2">
        <h5
          title="{{ conversation.effectiveTitle }}"
          [attr.data-test-id]="'conversation-title-' + i"
          [ngClass]="{
            'fw-bold':
              !conversation.lastMessage?.isRead && !isSentByCurrentUser(conversation.lastMessage?.sender?.userId)
          }"
        >
          {{ conversation.effectiveTitle }}
        </h5>
        <p
          *ngIf="conversation.lastMessage"
          [attr.data-test-id]="'conversation-last_message-' + i"
          class="last-message"
          [ngClass]="{
            'fw-bold': !conversation.lastMessage.isRead && !isSentByCurrentUser(conversation.lastMessage.sender.userId)
          }"
        >
          {{ conversation.lastMessage.text }}
        </p>
      </div>
    </div>
  </div>
  <div class="btn-holder">
    <button data-test-id="blocked-users-button" type="button" routerLink="/blocked-users" class="btn btn-link">
      {{ 'CHAT_BTN_SEE_BLOCKED_USERS' | translate }}
    </button>
  </div>
</div>
